export const THEME_STORAGE_KEY = 'theme';

export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
};

export const DEFAULT_THEME = THEMES.DARK;

export const LANG_STORAGE_KEY = 'lang';

export const LANGS = {
  PT: 'pt',
  EN: 'en',
};

export const DEFAULT_LANG = LANGS.PT;
